// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "bundle." + "paella" + "." + "8516e750af871718f712" + ".js";
};